// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1SGyp","actionsCol":"EnrolledClinics_actionsCol__IwDha"};